/**
 * The coverage pages' chrome, in English — every heading, label and notice on /coverage and /coverage/<code>.
 * ONE PLACE, so scripts/translate_coverage.py can find every sentence and the pages can look each one up in
 * the reader's language (src/lib/mycio/coverageI18n.ts). `{name}` is the one placeholder; keep it literal.
 *
 * The country DATA (what is encoded, what is being verified, refusals) stays in coverageDetail.ts and
 * marketingCoverage.ts, where it is derived from code; the same script translates those strings too.
 */
export const COVERAGE_UI = {
  // shared
  validated: 'Validated',
  provisional: 'Provisional',
  validatedNote: 'validated by our own worked cases',
  provisionalNote: 'modelled, some rules still being verified',
  estimateFooter: 'Figures are estimates for planning — computed, not advice. They are not tax-filing grade and not a substitute for a licensed adviser. Every country page lists what is encoded and what is not.',
  readDisclosures: 'Read the disclosures',
  machineTranslated: 'Machine-translated from English. The English page is the reference text; where wording matters, read that one.',
  included: 'Included:',
  assumed: 'Assumed:',
  notCovered: 'Not covered:',

  // /coverage
  indexEyebrow: 'Tax, modelled where you live',
  indexTitleBefore: 'Ten launch countries — and exactly what each one ',
  indexTitleEm: 'covers',
  indexTitleAfter: '.',
  indexLead: 'The United States and United Kingdom are validated by our own worked cases. Canada, Germany, France, Italy, Spain, Portugal, the Netherlands and Switzerland are provisional: modelled, with some rules still being verified. Open a country to see the tax year and law it is encoded from, what the engine covers, what is still being verified and when MyCIO will refuse to give a figure.',
  validatedCardSentence: 'Validated by our own worked cases. Figures are still estimates for planning, not tax-filing grade.',
  openCountry: 'What is encoded and what is not →',
  enginesEyebrow: 'What the engine covers',
  sixAreasTitle: 'Six areas, in every country — with what is included, assumed and excluded.',
  sixAreasLead: 'The same six areas appear on every country page. A country name is not a promise that every household or transaction is covered.',

  // /coverage/<code>
  backToAll: '← All ten launch countries',
  countryEyebrow: 'Tax coverage',
  validatedSentence: 'Validated by our own worked cases.',
  stillEstimates: 'Figures are estimates for planning — computed, not advice — and not tax-filing grade.',
  encodedTitle: 'What is encoded',
  editionLabel: 'Tax year / edition',
  lawLabel: 'Law',
  rulesLabel: 'Rules represented',
  limitsLabel: 'Limits to check',
  noScope: 'No scope record is published for this country yet.',
  sixAreasCountryLead: 'Six areas. Each one says what is included, what is assumed and what is not covered. A rule’s presence does not mean every combination is supported.',
  verifyingTitle: 'What is still being verified',
  noOpenItems: 'No open items are recorded for {name} on its own. Our worked cases for it pass; the figures remain estimates for planning.',
  refusesTitle: 'When MyCIO refuses to answer',
  refusesLead: 'MyCIO will refuse to give a figure when…',
  noRefusals: 'No refusal rules are recorded for {name} on its own. MyCIO still refuses a figure whenever a plan needs a rule that is not encoded, instead of guessing.',
  crossBorderLabel: 'Cross-border',
  otherCountries: 'Other launch countries',
} as const

export type CoverageUiKey = keyof typeof COVERAGE_UI
